import { LOCALES_SUPPORTED_CUSTOMER_FACING } from 'constants/locales'
import { PopoutMenu, styled } from 'opensolar-ui'
import { useMemo } from 'react'
import { getLocales } from 'resources/documentTemplates/util'
import CountryAndLocaleSelector from './CountryAndLocaleSelector'
import { ExpoNavLinkButton } from './ExpoNavLinkButton'
import useExpoContext from './hooks/useExpoContext'
import { Locale } from './hooks/useUserDefaults'

const FlagCircle = styled('div', { name: 'FlagCircle' })`
  font-size: 30px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const StyledExpoNavLinkButton = styled(ExpoNavLinkButton, { name: 'StyledExpoNavLinkButton' })`
  display: flex;
  gap: 5px;
`

export const CountryAndLocaleMenuButton = () => {
  const { selectedLocale, selectedCountry, availableCountries } = useExpoContext()
  const locales = useMemo(
    () => (getLocales(LOCALES_SUPPORTED_CUSTOMER_FACING) as Locale[]).filter((locale) => !!locale.id),
    []
  )
  const countryDisplay = useMemo(() => {
    const match = availableCountries?.find(
      (country) => country.iso2?.toLocaleLowerCase() === selectedCountry?.toLocaleLowerCase()
    )
    return match?.flag
  }, [selectedCountry, availableCountries])

  const localeDisplay = useMemo(() => {
    const match = locales?.find((lang) => lang.id?.toLocaleLowerCase() === selectedLocale?.toLocaleLowerCase())?.id?.toUpperCase()
    if (match === 'EN_US') return 'EN (US)'
    if (match === 'ES_MX') return 'ES (Mexico)'
    return match
  }, [selectedLocale, locales])

  return (
    <PopoutMenu
      menuId="ln-selector"
      anchorEl={
        <StyledExpoNavLinkButton>
          <FlagCircle>{countryDisplay}</FlagCircle>
          {localeDisplay}
        </StyledExpoNavLinkButton>
      }
    >
      <CountryAndLocaleSelector locales={locales} availableCountries={availableCountries} />
      <br></br>
    </PopoutMenu>
  )
}
